import ChatWidget from '../../../components/ChatWidget/ChatWidget';

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 text-white">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/certified_firm.jpg"
          alt="Certified Firm Background"
          className="w-full h-full object-cover"
        />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>

      <div className="container-custom relative z-10 py-24 md:py-32">
        <div className="max-w-4xl text-center md:text-left">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6">
            Real-Time Tools<br />
            <span className="text-accent-400"> For Proof of<br />Reserves auditing activities.</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-200 font-light">
            Transparency reporting at the speed of innovation.
          </p>
        </div>
      </div>

      {/* Chat Widget */}
      <ChatWidget />
    </section>
  );
};

export default Hero;
